import React from "react";
import CardContainer from "../CardContainer/CardContainer";
import "./Body.css";

const Body = () => {
  return (
    <div className="body">
      <CardContainer />
    </div>
  );
};

export default Body;
